import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Play, Star, Heart, Sparkles } from 'lucide-react'

export const WorldCard = ({ world, onClick, index = 0 }) => {
  const [likes, setLikes] = useState({ count: 0, liked: false })

  useEffect(() => {
    // 从 localStorage 获取点赞数据
    const getLikes = (type, id) => {
      const key = `likes_${type}_${id}`
      const data = localStorage.getItem(key)
      return data ? JSON.parse(data) : { count: 0, liked: false }
    }
    
    const worldId = world.worldId || world.id
    const likesData = getLikes('world', worldId)
    setLikes(likesData)
  }, [world])

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
    if (num >= 1000) return (num / 1000).toFixed(1) + 'k'
    return num.toString()
  }

  return (
    <motion.div
      className="world-card"
      onClick={() => onClick(world)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      whileHover={{ 
        scale: 1.05,
        y: -8,
        transition: { duration: 0.3 }
      }}
    >
      {/* 封面图 - 全屏 */}
      <div className="card-cover">
        {world.coverImage ? (
          <img src={world.coverImage} alt={world.name} />
        ) : (
          <div className="card-cover-placeholder">
            <Sparkles className="w-12 h-12 text-primary opacity-50" />
          </div>
        )}
        {/* 底部渐变遮罩 */}
        <div className="card-overlay"></div>
      </div>
      
      {/* 卡片内容 - 覆盖在图片底部 */}
      <div className="card-content">
        <h3 className="card-title">{world.name}</h3>
        
        <p className="card-description">
          {world.description && world.description.length > 60
            ? world.description.substring(0, 60) + '...'
            : world.description || '暂无描述'}
        </p>
        
        {/* 创作者 */}
        {world.creator && (
          <div className="card-creator">
            {world.creator.avatar && (
              <img 
                src={world.creator.avatar} 
                alt={world.creator.name} 
                className="creator-avatar"
              />
            )}
            <span className="creator-name">{world.creator.name || '未知'}</span>
          </div>
        )}
        
        {/* 标签 */}
        {world.tags && world.tags.length > 0 && (
          <div className="card-tags">
            {world.tags.slice(0, 3).map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        )}
        
        {/* 指标 */}
        <div className="card-metrics">
          <div className="metric">
            <Play className="w-4 h-4" />
            <span>{formatNumber(world.playCount || 0)}</span>
          </div>
          <div className="metric">
            <Heart className="w-4 h-4" />
            <span>{formatNumber(likes.count || 0)}</span>
          </div>
          <div className="metric">
            <Star className="w-4 h-4" />
            <span>{(world.rating || 0).toFixed(1)}</span>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

